export const getCouponStatusRemarks = (item) => {
  switch (item.status) {
    case 'CREATED':
      return `此優惠已在 ${item.remarks} 建立。`;
    case 'PENDING':
      return '此優惠正等待審批中。';
    case 'APPROVED':
      return `此優惠已在 ${item.createdAt} 審批。`;
    case 'SCHEDULED':
      return `此優惠已排程在 ${item.remarks} 在U Lifestyle 平台發佈。`;
    case 'PUBLISHED':
      return `此優惠已在 ${item.remarks} 在U Lifestyle 平台發佈。`;
    case 'REJECTED':
      return item.remarks;
    case 'STOPPED':
      return `此優惠已在 ${item.createdAt} 暫停發佈。`;
    case 'EXPIRED':
      return `此優惠已在 ${item.remarks} 下架。`;
    case 'REMOVED':
      return `此優惠已在 ${item.createdAt} 移除。`;
    default:
      return null;
  }
};

export default (item) => {
  let text;
  switch (item.status) {
    case 'APPROVED':
      text = '已審批';
      break;
    case 'REJECTED':
      text = '已拒絕';
      break;
    case 'EXPIRED':
      text = '已過期';
      break;
    case 'STOPPED':
      text = '已暫停';
      break;
    case 'SCHEDULED':
      text = '已排程';
      break;
    case 'PUBLISHED':
      text = '已發佈';
      break;
    case 'CREATED':
      text = '已建立';
      break;
    case 'ACTIVATED':
      text = '已啓用';
      break;
    case 'INACTIVATED':
      text = '已停用';
      break;
    case 'REMOVED':
      text = '已移除';
      break;
    case 'PENDING':
    default:
      text = '審批中';
      break;
  }
  return { text, value: item.status.toLowerCase() };
};
